import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import './grid.css';
import { setTimeout, setInterval, clearInterval } from 'timers';
import GridFilter from './filter/filter.jsx';
import SortOrder from './sortOrder.jsx';
import TrackVisibility from '../controls/trackVisibility.jsx';
import { apiGet, apiPost } from '../services/apiClient';
import { isUndefined } from 'util';

export default class Grid extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            boxHeight: '200px',
            tableWidth: '100px',
            tableHeight: '200px',
            tableHeaderHeight: '50px',
            tableBodyHeight: '200px',
            minTableWidth: '100px',
            gridKey: this.props.gridKey,
            columns: this.props.columns,
            filters: [],
            order: null,
            rows: [],
			takeCount: 30,
			requestedCount: 0,
			isFullLoaded: false,
			isLoading: false
        };

        this.initActualWidth();

        this.fixPosition = this.fixPosition.bind(this);
        this.fixPositionDelayed = this.fixPositionDelayed.bind(this);
        this.checkPositionTimer = null;
    }

    componentDidMount() {
        window.addEventListener("resize", this.fixPosition);
        $('.content-wrapper').on("minHeight.updated", this.fixPosition);

        var sidebarButton = $('body');
        sidebarButton.on('expanded.pushMenu', this.fixPositionDelayed);
        sidebarButton.on('collapsed.pushMenu', this.fixPositionDelayed);

        $.fn.originCss = $.fn.css;
        $.fn.css = this.jqueryCss;

        this.fixPosition();

        this.checkPositionTimer = setInterval(() => this.checkPosition(), 1000);

        this.loadSettings()
            .then(() => this.reload());
    }

    componentWillUnmount() {
        $.fn.css = $.fn.originCss;

        window.removeEventListener("resize", this.fixPosition);
        $('.content-wrapper').off("minHeight.updated", this.fixPosition);

        var sidebarButton = $('body');
        sidebarButton.off('expanded.pushMenu', this.fixPositionDelayed);
        sidebarButton.off('collapsed.pushMenu', this.fixPositionDelayed);

        if (this.checkPositionTimer) {
            clearInterval(this.checkPositionTimer);
        }
    }

    getSettings() {
        return {
            filters: this.state.filters,
            order: this.state.order
        };
    }

    jqueryCss(prop, value) {
        var result = $.fn.originCss.apply(this, arguments);
        var $this = $(this);
        if ($this.hasClass('content-wrapper') && value) {
            $this.trigger('minHeight.updated');
        }
        return result;
    }

    initActualWidth() {
        this.state.columns.map((column, ind, arr) => {
            column.actualWidth = column.minWidth;
        });
    }

    fixPositionDelayed() {
        setTimeout(() => this.fixPosition(), 300);
    }

    fixPosition() {
        var contentBody = $('.content');
        var targetBox = contentBody.find('.grid-box');

        var targetBoxHeight = this.getTableBoxHeight(contentBody, targetBox);
        var tableDimensions = this.getTableDimensions(contentBody, targetBox, targetBoxHeight);
        var minTableWidth = this.getMinTableWidth();

        this.updateActualColumnsWidth(tableDimensions.width, minTableWidth);

        this.setState({
            boxHeight: targetBoxHeight + 'px',
            tableHeight: tableDimensions.height + 'px',
            tableWidth: tableDimensions.width + 'px',
            tableHeaderHeight: tableDimensions.headerHeight + 'px',
            tableBodyHeight: tableDimensions.bodyHeight + 'px',
            minTableWidth: minTableWidth + 'px'
        });
    }

    checkPosition() {
        let contentBody = $('.content');
        let targetBox = contentBody.find('.grid-box');
        let boxBody = targetBox.find('.box-body');
        let tableHeader = boxBody.find('.grid-header');
        let tableHeaderHeight = tableHeader.outerHeight() + 'px';

        if (tableHeaderHeight !== this.state.tableHeaderHeight) {
            this.fixPosition();
        }
    }

    getDesignedContentHeight() {
        var contentWrapper = $('.content-wrapper');
        var minHeight = contentWrapper.css('min-height');
        if (minHeight && minHeight.indexOf('px') >= 0) {
            return parseFloat(minHeight.replace('px', ''));
        } else {
            return contentWrapper.innerHeight();
        }
    }

    getTableBoxHeight(contentBody, targetBox) {
        var contentHeader = $('.content-header');

        var designedHeight = this.getDesignedContentHeight();
        var targetMargins = targetBox.outerHeight() - targetBox.height();
        var contentBodyMargins = contentBody.outerHeight() - contentBody.height();
        var targetBoxHeight = designedHeight - contentHeader.outerHeight() - contentBodyMargins - targetMargins;
        return targetBoxHeight;
    }

    getTableDimensions(contentBody, targetBox, targetBoxHeight) {
        var boxHeader = targetBox.find('.box-header');
        var boxBody = targetBox.find('.box-body');
        var tableHeader = boxBody.find('.grid-header');

        var targetBoxBorders = targetBox.outerHeight() - targetBox.innerHeight();
        var boxBodyHorMargins = boxBody.outerWidth() - boxBody.width();
        var boxBodyVertMargins = boxBody.outerHeight() - boxBody.height();
        var tableHeight = targetBoxHeight - boxHeader.outerHeight() - boxBodyVertMargins - targetBoxBorders;
        var tableWidth = targetBox.innerWidth() - boxBodyHorMargins;
        var tableHeaderHeight = tableHeader.outerHeight();
        var tableBodyHeight = tableHeight - tableHeaderHeight;

        return {
            width: tableWidth,
            height: tableHeight,
            headerHeight: tableHeaderHeight,
            bodyHeight: tableBodyHeight
        };
    }

    getMinTableWidth() {
        var minTableWidth = 0;
        this.state.columns.map(function (column) {
            minTableWidth = minTableWidth + column.minWidth;
        });
        return minTableWidth;
    }

    updateActualColumnsWidth(tableWidth, minTableWidth) {
        var totalExpandPortions = 0;
        this.state.columns.map((column, ind, arr) => {
            totalExpandPortions = totalExpandPortions + this.getColumnExpandPortion(column);
        });
        var additionalWidth = tableWidth - minTableWidth;
        if (additionalWidth < 0) {
            additionalWidth = 0;
        }
        this.state.columns.map((column, ind, arr) => {
            column.actualWidth = column.minWidth + additionalWidth * this.getColumnExpandPortion(column) / totalExpandPortions;
        });
    }

    getColumnExpandPortion(column) {
        if (column.expandPortion) {
            return column.expandPortion;
        } else {
            return 1;
        }
    }

    loadSettings() {
        return apiGet('grid/settings/' + this.state.gridKey)
            .then(data => {
                let promise = new Promise((resolve, reject) => {
                    if (data) {
                        this.setState(
                            {
                                filters: data.filters ? data.filters : [],
                                order: data.order
                            },
                            () => resolve()
                        );
                    } else {
                        resolve();
                    }
                });
                return promise;
            });
    }

    applySettings() {
        let settings = this.getSettings();
        apiPost('grid/settings/' + this.state.gridKey, settings);
        this.reload();
    }

    clearSettings() {
		var hasFilters = this.state.filters && this.state.filters.length > 0;
        this.setState(
            {
                filters: [],
                order: null
            },
            () => {
				if (hasFilters && this.props.onFiltersChange) {
					this.props.onFiltersChange();
				}
				this.applySettings();
			}
        );
    }

    updateFilter(fieldName, filterValue) {
        this.setState(
			(prevState, props) => { 
				let newFilters = [];

				// оставляем все фильтры, кроме обновленного
				prevState.filters.map((filter, ind, arr) => {
					if (filter.fieldName !== fieldName) {
						newFilters.push(filter);
					}
				});

				// если фильтр не был удален, добавляем актуальное значение в конец списка
				if (filterValue) {
					newFilters.push(filterValue);
				}

				prevState.filters = newFilters;
				return prevState;
			}, 
			() => {
				if (this.props.onFiltersChange) {
					this.props.onFiltersChange();
				}
				this.applySettings();
			}
		);
    }

    toggleOrder(fieldName) {
        let newOrder = {
            fieldName: fieldName,
            order: "asc"
        };

        if (this.state.order && this.state.order.fieldName === fieldName && this.state.order.order === "asc") {
            newOrder.order = "desc";
        }

        this.setState({ order: newOrder }, () => this.applySettings());
    }

	loadNextPart(needOverlay) {
		if (this.state.rows.length >= this.state.requestedCount) {
			this.setState({ isLoading: true }, () => {
				let settings = this.getSettings();
				this.props.loadData(settings, this.state.takeCount, this.state.requestedCount, needOverlay)
					.then(rows => {
						this.setState((prevState, props) => { 
							prevState.isLoading = false;
							prevState.rows = prevState.rows.concat(rows);
							prevState.requestedCount = prevState.requestedCount + prevState.takeCount;
							prevState.isFullLoaded = rows.length < prevState.takeCount;
							return prevState;
						});
					});
			});
		}
	}

    reload() {
		this.setState({
            rows: [],
			requestedCount: 0
		}, () => {
			this.state.columns.forEach((column, ind, arr) => {
				if (column.filterControl && column.filterControl.reloadOptions) {
					column.filterControl.reloadOptions();
				}
			});
			this.loadNextPart(true);
		});
    }

    handleRowClicked(row) {
        if (this.props.onRowClicked) {
            this.props.onRowClicked(row);
        }
    }

	handleBottomRowVisible(isVisible) {
		if (isVisible && !this.state.isLoading && !this.state.isFullLoaded) {
			this.loadNextPart(false);
		}
	}

	renderTableRows() {
        return this.state.rows.map((row, rowInd) => {
            let rowKey = "row-" + rowInd;
			let isHighlighted = this.props.checkHighlight ? this.props.checkHighlight(row) : false;
			let rowClass = isHighlighted ? "info" : "";
            let cells = [];
            for (var colInd = 0; colInd < this.state.columns.length; colInd++) {
                let column = this.state.columns[colInd];
                let cellValue = this.props.renderCellValue(row, column);
                let cellKey = "cell-" + rowInd + "-" + colInd;
                let cellClass = column.cellClass ? column.cellClass : "";
                cells.push(
                    <td style={{ width: column.actualWidth, maxWidth: column.actualWidth }} className={cellClass} key={cellKey}>
                        {cellValue}
                    </td>
                );
            }
            return (
                <tr key={rowKey} className={rowClass} onClick={() => this.handleRowClicked(row)}>
                    {cells}
                </tr>
            );
        });
	}

	renderColumnHeaders() {
        return this.state.columns.map((column, ind) => {
            let columnKey = "col-" + ind;
            let columnOrder = null;
            if (this.state.order && this.state.order.fieldName === column.fieldName) {
                columnOrder = this.state.order.order;
            }

            let sortElement = <SortOrder order={columnOrder} />;
            if (column.disableSort) {
                sortElement = null;
            }

            let columnTitle = column.title ? column.title : "";
            if (column.renderTitle) {
                columnTitle = column.renderTitle();
            }

            return (
                <th style={{ width: column.actualWidth, maxWidth: column.actualWidth }}
                    key={columnKey}
                    onClick={() => {
                        if (isUndefined(column.disableSort) || !column.disableSort) {
                            this.toggleOrder(column.fieldName);
                        }
                    }}
                >
                    {columnTitle}
                    {sortElement}
                </th>
            );
        });
	}

	renderColumnFilters() {
        let settings = this.getSettings();
        return this.state.columns.map((column, ind) => {
            let filterKey = "col-filter-" + ind;
            let filterValue = null;
            if (this.state.filters) {
                this.state.filters.map((filter, fInd, fArr) => {
                    if (filter.fieldName === column.fieldName) {
                        filterValue = filter;
                    }
                });
            }
            return (
                <td style={{ width: column.actualWidth, maxWidth: column.actualWidth }} key={filterKey}>
                    <GridFilter column={column}
                        value={filterValue}
                        disabled={this.props.disableFilters}
                        onChange={(fieldName, value) => this.updateFilter(fieldName, value)}
                        gridSettings={settings}
                        loadUrl={column.loadUrl}
                        columnWidth={column.actualWidth}
						ref={control => column.filterControl = control}
                    />
                </td>
            );
        });
	}

	renderLoadingRow() {
		if (this.state.isFullLoaded || this.state.rows.length < 1) {
			return null;
		} else {
			let columnsCount = this.state.columns.length;
			let loadingCell = <td colSpan={columnsCount}><i className="fa fa-refresh fa-spin"></i></td>;
			return (
				<TrackVisibility scrollViewId="tBodyScrollView" tag="tr" className="loading-row" 
					offset={500} partialVisibility={true} onChange={e => this.handleBottomRowVisible(e)}
				>
					{({ isVisible }) => loadingCell}
				</TrackVisibility>
			);
		}
	}
	
	renderTableBodyScrollView(props) {
		let finalProps = {
			...props, 
			id: "tBodyScrollView"
		} 
		return <div {...finalProps}/>;
	}

    render() {
        let tableRows = this.renderTableRows();
        let columnHeaders = this.renderColumnHeaders();
        let columnFilters = this.renderColumnFilters();
		let loadingRow = this.renderLoadingRow();

        let overlay = this.props.isBusy
            ? <div className="overlay">
                <i className="fa fa-refresh fa-spin"></i>
              </div>
            : null;

        return (
            <div>
                <div className="overlay-wrapper grid-overlay-wrapper"
                    style={{
                        height: this.state.tableBodyHeight,
                        width: this.state.tableWidth,
                        marginTop: this.state.tableHeaderHeight
                    }}
                >
                    {overlay}
                </div>
                <Scrollbars autoHeight autoHeightMax="10000" style={{ width: this.state.tableWidth }}>
                    <div className="grid-wrapper" style={{ minWidth: this.state.minTableWidth, height: this.state.tableHeight }}>
                        <table className="table table-bordered table-hover grid-header">
                            <thead>
                                <tr>
                                    {columnHeaders}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {columnFilters}
                                </tr>
                            </tbody>
                        </table>
                        <Scrollbars style={{ height: this.state.tableBodyHeight }} renderView={this.renderTableBodyScrollView}>
                            <table className="table table-bordered table-hover grid-body">
                                <tbody>
                                    {tableRows}
									{loadingRow}
                                </tbody>
                            </table>
                        </Scrollbars>
                    </div>
                </Scrollbars>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/grid/grid.jsx